module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list simulation-produce"
  }, [_c('div', {
    staticClass: "children-head"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("模拟生产")]), _vm._v(" "), _c('span', {
    staticClass: "version"
  }, [_vm._v("公测版")]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("此模块为测试版本，不属于现阶段收费范畴，期待与您进行需求共创！")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "commun-wrap",
    attrs: {
      "element-loading-text": "开始模拟..."
    }
  }, [_c('div', {
    staticClass: "field-out"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "124px"
    },
    attrs: {
      "for": "sheetNo"
    }
  }, [_vm._v("选择BOM")]), _vm._v(" "), _c('bom-field', {
    attrs: {
      "module": _vm.moduleName,
      "item": _vm.simulationItem,
      "form": _vm.simulationForm
    },
    on: {
      "emitObj": _vm.bomChange
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "save",
    attrs: {
      "type": "primary",
      "disabled": !_vm.bomObj.id
    },
    on: {
      "click": _vm.startSimulation
    }
  }, [_vm._v("\n        开始模拟\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "simulation-table"
  }, [_c('table', {
    staticClass: "tableclass",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("BOM")]), _vm._v(" "), _c('td', [(_vm.bomNo) ? [_c('span', [_vm._v("关联BOM清单：" + _vm._s(_vm.bomName) + "（编号" + _vm._s(_vm.bomNo) + "）")]), _vm._v(" "), _c('span', [_vm._v("BOM版本：" + _vm._s(_vm.bomVersion))])] : _c('span', {
    staticClass: "no-bom"
  }, [_vm._v("请选择BOM后模拟生产")])], 2)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("物料")]), _vm._v(" "), _c('td', [(_vm.bomNo) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "max-height": "400",
      "data": _vm.materielTableData
    }
  }, _vm._l((_vm.materielExplains), function(h, index) {
    return (h.attr !== 'unitNum') ? _c('el-table-column', {
      key: h.attr,
      attrs: {
        "label": h.attrName,
        "prop": h.attr
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(h.attr === 'warehouse') ? [_c('el-select', {
            attrs: {
              "size": "small",
              "value-key": "id",
              "placeholder": "请选择"
            },
            on: {
              "change": function($event) {
                _vm.changeWareHouse(scope.$index, scope.row.result[index].attrValue)
              }
            },
            model: {
              value: (scope.row.result[index].attrValue),
              callback: function($$v) {
                _vm.$set(scope.row.result[index], "attrValue", $$v)
              },
              expression: "scope.row.result[index].attrValue"
            }
          }, _vm._l((scope.row.result[index].warehouseArray), function(op) {
            return _c('el-option', {
              key: op.id,
              attrs: {
                "label": op.value,
                "value": op
              }
            })
          }))] : (h.attr === 'stock') ? [_vm._v("\n                      " + _vm._s(scope.row.result[index].attrValue || 0) + "\n                    ")] : ([5, 6, 8, 10].indexOf(h.fieldType) === -1) ? [_c('span', [_vm._v(_vm._s(scope.row.result[index].attrValue || '--'))])] : _vm._e()]
        }
      }])
    }) : _vm._e()
  })) : _c('span', {
    staticClass: "no-bom"
  }, [_vm._v("请选择BOM后模拟生产")])], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("成品")]), _vm._v(" "), _c('td', [(_vm.bomNo) ? _c('div', {
    staticClass: "ed-product"
  }, [_c('img', {
    attrs: {
      "src": _vm.finishedProduct.thumbnail
    },
    on: {
      "click": function($event) {
        _vm.imgBig(_vm.finishedProduct.thumbnail)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product-Info"
  }, [_c('p', [_vm._v("产品名称：" + _vm._s(_vm.finishedProduct.productName || '--'))]), _vm._v(" "), _c('p', [_vm._v("产品编号：" + _vm._s(_vm.finishedProduct.productNo || '--'))]), _vm._v(" "), _c('p', [_vm._v("规格：" + _vm._s(_vm.finishedProduct.specification || '--'))])]), _vm._v(" "), _c('div', {
    staticClass: "product-Num"
  }, [_c('p', [_vm._v("库存总数量：" + _vm._s(_vm.finishedProduct.stock))]), _vm._v(" "), _c('p', [_vm._v("可生产数量：" + _vm._s(_vm.simulationForm.canNum) + "\n                    "), _c('el-tooltip', {
    attrs: {
      "content": "可生产数量：根据物料库存数量，以及关联BOM清单中设定的物料标准用量及其损耗率计算所得。",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('span', {
    staticClass: "icon el-icon-question"
  })])], 1)])]) : _c('span', {
    staticClass: "no-bom"
  }, [_vm._v("请选择BOM后模拟生产")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('el-button', {
    staticClass: "save",
    attrs: {
      "type": "warning",
      "disabled": _vm.afterSimulation
    },
    on: {
      "click": _vm.oneKey
    }
  }, [_vm._v("一键生产")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-438730d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/simulation-produce/index.vue
// module id = 1257
// module chunks = 82